import React, { memo } from "react";

interface IRefreshIconProps {
  size?: number;
}

const RefreshIcon: React.FC<IRefreshIconProps> = memo(({ size = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="currentColor"
    >
      <path
        d="M0 24.4999L0 14H10.5L5.6745 18.83C6.49871 19.6728 7.48256 20.343 8.56861 20.8014C9.65467 21.2598 10.8212 21.4973 12 21.5C13.8589 21.4972 15.6713 20.919 17.1883 19.8446C18.7053 18.7703 19.8524 17.2526 20.472 15.5H20.499C20.67 15.0125 20.8005 14.51 20.8875 14H23.9055C23.5402 16.8998 22.129 19.5666 19.937 21.4998C17.745 23.4331 14.9227 24.4999 12 24.4999H11.985C10.4097 24.5047 8.84916 24.1969 7.39365 23.5944C5.93813 22.9919 4.61658 22.1067 3.5055 20.99L0 24.4999ZM3.111 11H0.0929997C0.458214 8.10123 1.86846 5.43526 4.05923 3.50216C6.25001 1.56905 9.07079 0.501613 11.9925 0.50006H12C13.5755 0.495071 15.1364 0.802737 16.5922 1.40524C18.048 2.00774 19.3698 2.8931 20.481 4.01004L24 0.50006V11L13.5 11L18.333 6.17003C17.508 5.32625 16.5229 4.6555 15.4355 4.19705C14.3481 3.73859 13.1801 3.50163 12 3.50005C10.1411 3.50279 8.32869 4.08106 6.81171 5.1554C5.29473 6.22974 4.14763 7.74745 3.528 9.50002H3.501C3.3285 9.98752 3.1965 10.49 3.111 11Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { RefreshIcon };
